import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import homeLogo from '../../Assets/rp5.jfif'
import Particle from '../Particle'
import Button from 'react-bootstrap/Button'
import { BiLinkExternal } from 'react-icons/bi'
import rpprevention from '../../Assets/rpprevention.jfif'
import { FaTelegramPlane, FaDiscord, FaTwitter, FaMedium } from 'react-icons/fa'

function AboutUs() {
  return (
    <section>
      <Container fluid className="ds-section" id="aboutus">
        <Particle />
        <Container className="home-content">
          <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
            <Col
              md={12}
              style={{ justifyContent: 'center', paddingBottom: '10px' }}
            >
              {/* <img src={homeLogo} width="100%" className="ds-img" alt="home pic"/> */}
              <h1 className="ds-header-image">ABOUT RUGPULL PREVENTION</h1>
            </Col>
          </Row>
          <Row>
          <Col md={4}>
            <img src={rpprevention} width="100%" className="ds-img" alt="home pic"/>
          </Col>
          <Col md={8}>
          <br/>
          <br/>
          <h2>Read how RUGPULL PREVENTION cam to be</h2><br/>
          <br/>
          <Button variant="warning" width="60%" href="https://rugpullprevention.medium.com/the-story-of-rugpull-prevention-21f690b7346c" target="_blank">
          <FaMedium />
            {"---- STORY OF RUGPULL PREVENTION ----"}
          </Button>
          <br/>
          <br/>
          <br/>
          <h2>What is Rugpull Prevention?</h2>
          <p>
          <span className="home-about-body">Rugpull Prevention is a Web Development entity that builds on the Avalanche Network. Rugpull Prevention is building a DAO that will decentralize our processes. We will offer custom DeFi safety tools through this DAO as well as community on chain voting for Detective scores, and allow proposals from the community. Our vision is to have an open source platform that anyone can build upon to create easy to use tools for DeFi.&nbsp;</span>
          </p>
          <br/>
          <h2>Team Members</h2><br/>
          <p>
          <span className="home-about-body">We currently have 3 core team members. Please read our medium below for a full introduction to our team.&nbsp;</span><br/>
          </p>
          <br/>
          <Button variant="warning" width="80%" href="https://rugpullprevention.medium.com/rugpull-prevention-is-now-a-team-effort-e2a260d5d244" target="_blank">
          <FaMedium />
            {"---- CLICK TO READ MEDIUM ABOUT TEAM MEMBERS ----"}
          </Button>
          <br/>
          <br/>
          <br/>
          <h2>What is th RUGPULL Token?</h2>
          <p>
          <span className="home-about-body">The RUGPULL token that is tradable on Pangolin is not owned by anyone. The token is a community token. A community token is similar to Ravencoin or DOGE, in which there is no owner. Rugpull Prevention will use RUGPULL for many uses in the future. Please see our Roadmap and Roadmap Update Medium article that explains our plans in detail. &nbsp;</span>
          </p>
          <br/>
          </Col>
          </Row>

          <Row
            style={{
              justifyContent: 'center',
              paddingTop: '40px',
              paddingBottom: '10px',
            }}
          >
            <Col
              md={3}
              style={{ justifyContent: 'center', paddingBottom: '10px' }}
            >
              <Button
                variant="warning"
                width="60%"
                href="https://www.twitter.com/AvaxDyor"
                target="_blank"
              >
                <FaTwitter />
                {'---- CLICK FOR Twitter ----'}
              </Button>
            </Col>
          </Row>

          <Row
            style={{
              justifyContent: 'center',
              paddingTop: '100px',
              paddingBottom: '10px',
            }}
          ></Row>
        </Container>
      </Container>
    </section>
  )
}

export default AboutUs
